/**
 * Created by Bowen on 5/24/2020.
 * Description:
 * Add contact body component
 *
 * ------ maintenance history ------
 */
import { Component, OnInit, Input, ViewChild, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ContactDetailService } from '../../contact-body-detail.service';
import { ContextMenuService, ContextMenuComponent } from '@perfectmemory/ngx-contextmenu';
import { ContactBasicInformationCategory, ContactComponentActionTypes, ContactComponentCategory } from '../../contact-body-detail.model';
import { Subscription, fromEvent } from 'rxjs';
import { businessConstants } from '../../../../constants/business.constants';
import { SlideSheetEventTypes } from '../../../slide-sheet/slide-sheet.model';
import { SlideSheetService } from '../../../../services/slide-sheet.service';

@Component({
    selector: 'tam-contact-note',
    templateUrl: './contact-note.component.html',
    styleUrls: ['./contact-note.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactNoteComponent implements OnInit, OnDestroy {
    @Input() config;
    @ViewChild('contextItemMenu', { static: false }) itemMenuEle: ContextMenuComponent<any>;

    isCollapse = false;
    contextMenu: Array<any>;
    noDataStyle = 'none';
    windowSize: number;
    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _contactDetailService: ContactDetailService,
        private _contextMenuService: ContextMenuService<any>,
        private _changeDetectorRef: ChangeDetectorRef,
        private _slideSheetService: SlideSheetService
    ) {
    }

    ngOnInit() {
        // will control if it will collapse: 1 will collapse, 0 will not collapse
        if (this.config && this.config.isCollapsed === '1') {
            this.isCollapse = true;
        }
        this._initContextMenu();
        this.windowSize = window.innerWidth;
        this._destroySubscriptions.push(
            fromEvent(window, 'resize').subscribe((e: any) => {
                this.isCollapse = false;
                this.windowSize = e.target.innerWidth;
                this._updateChangesToUI();
            }),
            // Listening the change of the contact
            this._slideSheetService.slideSheetFeedbackSubject$.subscribe(res => {
                // Update contact note information
                if (res.type === SlideSheetEventTypes.CONTACT_VALUE_CHANGE) {
                    this._setNoteStyleByData();
                    this._changeDetectorRef.detectChanges();
                }
            })
        );
        this._setNoteStyleByData();
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    // will watch the meatball click
    onMeatball(event: MouseEvent, item: any) {
        this._contextMenuService.show(this.itemMenuEle, { x: event.clientX, y: event.clientY });
        event.preventDefault();
        event.stopPropagation();
    }

    // will watch the menu select after clicking the meatball
    onMenuSelect(event) {
        const type = event.event.target.innerText;
        if (type === ContactComponentActionTypes.COLLAPSE_TILE) {
            this.isCollapse = true;
            this._contactDetailService.action$.next({
                type: ContactComponentActionTypes.COLLAPSE_TILE,
                payload: {
                    origin: ContactComponentCategory.ContactNote,
                    originPosition: this.config.position
                }
            });
        } else if (type === ContactComponentActionTypes.EXPAND_TILE) {
            this.isCollapse = false;
            this._contactDetailService.action$.next({
                type: ContactComponentActionTypes.EXPAND_TILE,
                payload: {
                    origin: ContactComponentCategory.ContactNote,
                    originPosition: this.config.position
                }
            });
        } else {
            this._contactDetailService.action$.next({
                type: ContactComponentActionTypes.CHANGE_COMPONENT,
                payload: {
                    origin: ContactComponentCategory.ContactNote,
                    target: type,
                    originPosition: this.config.position
                }
            });
        }
    }

    trackByFn(index, item) {
        return item.id;
    }

    // init the context menu data
    private _initContextMenu() {
        this.contextMenu = [
            { id: ContactBasicInformationCategory.BasicInformation, title: ContactBasicInformationCategory.BasicInformation },
            { id: ContactBasicInformationCategory.ContactInformation, title: ContactBasicInformationCategory.ContactInformation },
            { id: ContactBasicInformationCategory.Employment, title: ContactBasicInformationCategory.Employment },
            { id: ContactBasicInformationCategory.Address, title: ContactBasicInformationCategory.Address },
            { id: ContactBasicInformationCategory.Internet, title: ContactBasicInformationCategory.Internet },
            { id: ContactBasicInformationCategory.Other, title: ContactBasicInformationCategory.Other },
        ];
    }

    private _setNoteStyleByData() {
        if (this.config.data) {
            this.noDataStyle = 'none';
        } else {
            this.noDataStyle = 'flex';
        }
    }

    private _updateChangesToUI() {
        if (!this._changeDetectorRef[businessConstants.common.changeDetectorDestroyedIdentifier]) {
            this._changeDetectorRef.detectChanges();
        }
    }
}
